import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { LiveVideoService } from 'src/app/services/liveVideo.service';
import videojs from 'video.js';
import '@videojs/http-streaming'
import { WebRTCAdaptor } from '@antmedia/webrtc_adaptor';
import { DomSanitizer } from '@angular/platform-browser';
import { VideoService } from 'src/app/services/video.service';
import { MirrorEvent, SignalRService } from 'src/app/services/signalR.service';
import { AuthService } from 'src/app/services/auth.service';
import { Role } from 'src/app/shared/role';

@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.scss'],
})
export class VideoDialogComponent  implements OnInit, OnDestroy  {
  @ViewChild('localVideo', { static: false }) localVideo!: ElementRef<HTMLVideoElement>;
  @Input() videoUrl = '';
  @Input() name = '';
  @Input() userId = '';
  url: any;
  title: any;
  player: any;
  format: string = '';
  rtcLink = '';
  webRTCAdaptor: any;
  isWebRtc = false;
  iframeUrl: any;
  
  constructor(private modalCtrl: ModalController, private videoService: LiveVideoService,
    private vdService: VideoService,
    private sanitizer: DomSanitizer,
    private signalRService: SignalRService,
    private authService: AuthService
  ) { }

  async ngOnInit() {
    const currentUser = await this.authService.getCurrentUserValue();
    // const streamId = '1xq0ovjf5tMoLgoFf49b7k';
    // this.webRTCAdaptor = new WebRTCAdaptor({
    //   websocket_url: "wss://stream.sen3i.com:5443/live/websocket",
    //   remoteVideoElement: document.getElementById("remoteVideo"),
    //   isPlayMode: true,
    //    peerconnection_config: {
    //         iceServers: [
    //         { urls: "stun:stun.l.google.com:19302" },
    //         { urls: "turn:40.90.170.220:3478", username: "azureuser", credential: "B4t3Array123#" }
    //         ]
    //     },
    //   callback: (info: any, obj: any) => {
    //     console.log("callback info: " + info);
    //       if (info === "initialized") {
    //         this.webRTCAdaptor.play(streamId);
    //         }
    //     if (info == "play_started") {
    //         console.log("publish started");
    //         // statusInfo.innerHTML = "Playing - Stream Id:" + streamId; 
    //     }
    //     else if (info == "play_finished") {
    //         console.log("publish finished")
    //         // statusInfo.innerHTML = "Offline"
    //     }
    //   },
      
    // });
    this.videoService.getLiveVideo(this.userId).subscribe(async res => {
      this.title = res.name;
      this.url = res.link;
      this.format = res.videoFormat;
      this.rtcLink = res.rtmpLink;
      const format = this.parseWebSocketUrl(this.rtcLink);
      console.log("view", res.link);
      console.log("parseWebSocketUrl", format);
      if(this.rtcLink.includes('wss://')){
        this.isWebRtc = true
        this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(res.link);
        // await this.vdService.play(this.localVideo.nativeElement, format.baseUrl, format.streamId);
      } else {
        this.showVideo();
      }
      
    });

    this.doSubscribeMirrorEvent();
  }

  doSubscribeMirrorEvent() {
    if(!this.authService.hasRole(Role.ClientMirror))
      return;
    
    this.signalRService.mirrorMessages$.subscribe(async (messages: MirrorEvent[]) => {
        const event = messages[0];
        console.log(event.type, event.payload);
        if (event.type === "broadcast-close") {
          this.modalCtrl.dismiss();
        }
    });
  }

  parseWebSocketUrl(url: string) {
    try {
      const u = new URL(url);

      // Split pathname to get last part (stream ID)
      const parts = u.pathname.split("/").filter(Boolean);
      const streamId = parts.pop() || "";

      // Base URL = protocol + host + everything before streamId
      const basePath = parts.join("/");
      const baseUrl = `${u.protocol}//${u.host}/${basePath}`;

      return { baseUrl, streamId };
    } catch (e) {
      throw new Error("Invalid WebSocket URL");
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  showVideo(){
    this.player = videojs('my-video', {
      autoplay: true,
      controls: true,
      responsive: true,
      fluid: false,
      sources: [
        {
          src: this.url,
          type: 'application/x-mpegURL'
        }
      ]
    });
  }

  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
    }

    if(this.webRTCAdaptor){
      this.webRTCAdaptor.stop()
    }
  }

}
